import { createAsyncThunk } from '@reduxjs/toolkit'
import api from '@services/api.service'
import { AxiosError } from 'axios'
import { DjangoErrorResponse } from '@store/slices/generic.slice'
import { toast } from 'react-toastify'
import {RegionalPost} from "@store/slices/regionalPost.slice";

const postsEndpoint = 'area-posts'

export const fetchPostsByAreaShortcut = createAsyncThunk(
  'areas/fetchRegionalPosts',
  async (props: { areaShortcut: string | null }) => {
    try {
      let query = ''
      if (!!props.areaShortcut) {
        query = `?areaShortcut=${props.areaShortcut}`
      }
      const response = await api.get(`${postsEndpoint}${query}`)
      return response.data.data as RegionalPost[]
    } catch (error) {
      const axiosError = error as AxiosError
      if (axiosError.response) {
        const serverError = axiosError.response.data as DjangoErrorResponse
        // toast.error(
        //   `Error: ${serverError.message || 'Nepodrařilo se stáhnout regionální články'}.`
        // ) TODO uncomment after better handling error on multiple regions
      } else {
        toast.error('Nepodrařilo se stáhnout regionální články')
      }
      throw axiosError
    }
  }
)
